import React from 'react';
import PropTypes from 'prop-types';
import AppEnv from './AppEnv';
import { getHomeWelcomeAlignClasses, getWelcomeTextClasses } from '../../utils/themeAndStyleHelpers';


const LoginWelcome = ({ title, subtitle = '' }) => {
  const homeWelcomeAlignClass = getHomeWelcomeAlignClasses();
  const welcomeTextClass = getWelcomeTextClasses();

  return (
    <div className={`home-welcome ${homeWelcomeAlignClass}`}>
      <div className="row">
        <div className="col">
          <div className={`${welcomeTextClass}`}>
            <h1>
              {title}
              <AppEnv />
            </h1>
            {
            subtitle
              ? <p>{subtitle}</p>
              : ''
          }
          </div>
        </div>
      </div>
    </div>
  );
};


LoginWelcome.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string
};

export default LoginWelcome;
